import { Action } from 'redux';
import { REPORT_FETCH } from 'src/modules/report/actions/ReportActions';
import { ReportState } from 'src/modules/report/types/ReportState';

export function reportFetchReducer(state: ReportState, action: Action): ReportState {
  if (REPORT_FETCH.is(action)) {
    return { status: null, data: action.data };
  }

  return state;
}
